import { LobCertOnlyCheckbox } from '@/components/bulk-job/LobCertOnlyCheckbox';
const LobWosRenderer = ({ data: lob, context }) => {
  if (!lob) {
    return '-';
  }

  const { onCertOnlyChange, formValuesLobs } = context;

  return (
    <LobCertOnlyCheckbox
      data={lob}
      field="wos"
      onCertOnlyChange={onCertOnlyChange}
      formValuesLobs={formValuesLobs}
    />
  );
};

export default LobWosRenderer;
